// This file was generated by "make codegen/iam". DO NOT EDIT.

import { APPLY_EXCEPTION_REVIEW_MUTATION as ACTION_MONDOO_POLICY_EXTENDEDHUB_APPLYEXCEPTIONREVIEWMUTATION } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/ApplyExceptionReviewMutation/action";
import { EXTEND_EXCEPTION_REVIEW as ACTION_MONDOO_POLICY_EXTENDEDHUB_EXTENDEXCEPTIONREVIEW } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/ExtendExceptionReview/action";

export const allowedActions = [
  ACTION_MONDOO_POLICY_EXTENDEDHUB_APPLYEXCEPTIONREVIEWMUTATION,
  ACTION_MONDOO_POLICY_EXTENDEDHUB_EXTENDEXCEPTIONREVIEW,
] as const;
